// extracted by mini-css-extract-plugin
module.exports = {"feedback_button":"GeneralFeedbackIcon_feedback_button__iYMIu","close_feedback":"GeneralFeedbackIcon_close_feedback__GPQV8"};